export default "__VITE_ASSET__g2B9ipwj__"